//tlszx
// const software = "e058e85d-443f-447d-89f4-1c646068acec";
// const URL = "https://tlszx.com";

//本地
// const software = "8a258d21-7d10-48fd-9300-89e202644763";
// const URL = "http://localhost:8089/tlszx";

//学校
const software = "d03fff0f-8085-4498-8708-4f034986b49c";
const URL = "/tlszx";

exports.install = function (Vue, options) {

	Vue.prototype.$RedirectTlszxSoftware = function (ilabParam) {
		let url = `${URL}/student/page/SoftwareDetails?softwareId=${software}`;

		if (ilabParam.ticket)
			url += `&ticket=${ilabParam.ticket}`;

		if (ilabParam.token)
			url += `&token=${ilabParam.token}`;

		window.location.href = url;
		return;
	};

	Vue.prototype.$RedirectTlszxExam = function () {
		window.location.href = `${URL}/student/page/ExaminationHome`
		return;
	};

	Vue.prototype.$RedirectTlszxPlace = function (place) {
		window.location.href = `${URL}${place}`
		return;
	};
};